import React from 'react';
import { useState } from 'react';
import { getContractsByAppointeeId, downloadContractPdfForAppointmentId } from './service';
import View from './RetrieveContract.view';
import errorCb from 'Common/Utils/errorCb';
import { useDispatch } from 'react-redux';
import { infoToastAction, errorToastAction } from 'utils';
import FileSaver from 'file-saver';

const RetrieveContractAndTerms = () => {
    document.title = `Contract Management - Retrieve Contract and Terms`;    
	const [data, setData] = useState([]);
	const [isSelected, setisSelected] = useState(false);
	const dispatch = useDispatch();
	const [searchId, setSearchId] = useState('');
	const [selectedRow, setSelectedRowState] = useState([]);
	const globalDispatch = useDispatch();

	const setSelectedRow = row => {
		setSelectedRowState(row);
		setisSelected(true);
	};

    //	Do the search
    const submit = async () => {
		await loadData();
	};

	const loadData = async () => {
		var result = [];

		if(searchId != '')
        {
            await getContractsByAppointeeId(searchId, errorCb([], 'Error fetching data.', dispatch)).then(res => {
                result = res;
			});
        }
		setData(result);
		setisSelected(false);
		setSelectedRowState([]);
		if(result.length == 0)
		{
			globalDispatch(infoToastAction('No results found for your search'));
		}
    }

    const downloadContractPdf = async () => {
        var result = [];

        var appointmentId = selectedRow.appointmentId;
        var year = selectedRow.qualificationYear;
        var appointmentType = selectedRow.baseType;
        await downloadContractPdfForAppointmentId(appointmentId, year, appointmentType, errorCb([], 'Error fetching Pdf.', dispatch)).then(res => {
            result = res;
        });
        
        const myBlob = new Blob([new Uint8Array(result.data).buffer], 
         {type: 'application/pdf'});

        //Build a URL from the file and open
       const fileURL = URL.createObjectURL(myBlob);
        window.open(fileURL);
    };

	return (
		<View
            data={data}
            submit={submit}
            setSearchId={setSearchId}
            onSelectionChange={setSelectedRow}
            isSelected={isSelected}
            selectedRow={selectedRow}
            downloadContractPdf={downloadContractPdf}
		/>
	);
};

export default RetrieveContractAndTerms;
